import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AppState } from 'src/store/appstate';
import { selectRouteParam } from 'src/store/router/router-selectors';
import { CompanyAuthorizationService } from '../company-authorization.service';

@Injectable({ providedIn: 'root' })
export class CompanyCodeGuard {
  constructor(
    private _companyAuthService: CompanyAuthorizationService,
    private _store: Store<AppState>,
  ) {}

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkCompanyCode();
  }

  public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkCompanyCode();
  }

  public checkCompanyCode() {
    return this._store.select(selectRouteParam('companyCode')).pipe(
      switchMap((companyCode) => {
        return companyCode == null
          ? of(true)
          : this._companyAuthService.isAuthorizedForCompany$({ companyCode });
      }),
    );
  }
}
